import * as React from 'react';

export const BuildDetailsScrollContainerContext = React.createContext(null);
